import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_FrameRunner1vxxn1vgayqf as get_FrameRunner } from './FrameRunner.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function FrameRunner(_this__u8e3s4, sequence, speed, child, key) {
  key = key === VOID ? null : key;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var component = get_FrameRunner();
  setDefaultKey(_this__u8e3s4, '@rdk/17_4');
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$component) => {
    $this$component.sequence = sequence;
    $this$component.speed = speed;
    $this$component.child = child;
    var tmp0_safe_receiver = key;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.key = tmp0_safe_receiver;
    }
    return Unit_instance;
  };
  addChild(_this__u8e3s4, component, block);
}
//region block: exports
export {
  FrameRunner as FrameRunner3h5m8z872haq7,
};
//endregion

//# sourceMappingURL=FrameRunnerKt.mjs.map
